import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["src", "alt"]


export default /*@__PURE__*/_defineComponent({
  __name: 'esButtonNavigation',
  props: {
    iconLeft: {},
    altLeft: {},
    iconRight: {},
    altRight: {},
    disabled: { type: Boolean },
    styles: {},
    buttonLabel: {}
  },
  emits: ['clickLeft', 'clickRight', 'clickButton'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const getClass = () => {
  const mainClass = props.disabled ? 'color-disabled' : '';

  const propsClass = props.styles ? props.styles : '';

  return [mainClass, propsClass];
};

const emits = __emit


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(_ctx.disabled ? 'border-radius-left button-disabled' : 'border-radius-left button-navigation'),
      disabled: _ctx.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('clickLeft')))
    }, [
      _createElementVNode("img", {
        class: _normalizeClass(getClass()),
        src: _ctx.iconLeft,
        alt: _ctx.altLeft
      }, null, 10, _hoisted_2)
    ], 10, _hoisted_1),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(_ctx.disabled ? 'button-disabled' : 'button-navigation'),
      disabled: _ctx.disabled,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('clickButton')))
    }, [
      _createVNode(_component_text_item, {
        txt: _ctx.buttonLabel,
        class: _normalizeClass(getClass()),
        alt: _ctx.buttonLabel
      }, null, 8, ["txt", "class", "alt"])
    ], 10, _hoisted_3),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(_ctx.disabled ? 'border-radius-right button-disabled' : 'border-radius-right button-navigation'),
      disabled: _ctx.disabled,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('clickRight')))
    }, [
      _createElementVNode("img", {
        class: _normalizeClass(getClass()),
        src: _ctx.iconRight,
        alt: _ctx.altRight
      }, null, 10, _hoisted_5)
    ], 10, _hoisted_4)
  ], 64))
}
}

})